var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPackageInternational(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 20H1.326A1.328 1.328 0 010 18.674V6.5A.5.5 0 01.5 6h19a.5.5 0 01.5.5v3a.5.5 0 01-1 0V7H1v11.674c0 .18.146.326.326.326H9.5a.5.5 0 010 1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 7a.498.498 0 01-.438-.259l-3.02-5.482A.497.497 0 0015.605 1H4.395a.5.5 0 00-.438.259L.937 6.741a.5.5 0 11-.875-.482L3.082.777C3.345.297 3.849 0 4.395 0h11.21c.546 0 1.05.297 1.313.776l3.02 5.482A.5.5 0 0119.5 7z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 7a.5.5 0 01-.5-.5v-6a.5.5 0 011 0v6a.5.5 0 01-.5.5zM17.5 24c-3.584 0-6.5-2.916-6.5-6.5s2.916-6.5 6.5-6.5 6.5 2.916 6.5 6.5-2.916 6.5-6.5 6.5zm0-12c-3.033 0-5.5 2.467-5.5 5.5s2.467 5.5 5.5 5.5 5.5-2.467 5.5-5.5-2.467-5.5-5.5-5.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 23.65a.5.5 0 01-.5-.5v-11.3a.5.5 0 011 0v11.3a.5.5 0 01-.5.5zM19.5 23.65a.5.5 0 01-.5-.5v-11.3a.5.5 0 011 0v11.3a.5.5 0 01-.5.5z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.15 16h-11.3a.5.5 0 010-1h11.3a.5.5 0 010 1zM23.15 20h-11.3a.5.5 0 010-1h11.3a.5.5 0 010 1z"
  })));
}

export default SvgPackageInternational;